module.exports = __webpack_public_path__ + "media/images/themes/spring_bohemian/Greenery-Wedding-a49686631740ad4e2110a4a18ea46355.png";